import MicroModal from 'micromodal';

export default class Modal {
    static init(): void {
        MicroModal.init({
            openTrigger: 'data-micromodal-trigger', // Atribut pro spuštění modalu
            closeTrigger: 'data-micromodal-close', // Atribut pro zavření modalu
            disableScroll: true, // Zakáže scrollování při otevřeném modalu
            disableFocus: false, // Povolí/zakáže auto-focus na prvním prvku
            awaitOpenAnimation: false, // Čeká na dokončení animace při otevření
            awaitCloseAnimation: false, // Čeká na dokončení animace při zavření
        });

        Modal.setupCustomOpenModal();
    }

    private static setupCustomOpenModal(): void {
        const openButtons = document.querySelectorAll('[data-micromodal-trigger]');
        openButtons.forEach(button => {
            button.addEventListener('click', () => {
                const modalId = button.getAttribute('data-micromodal-trigger');
                if (modalId) {
                    MicroModal.show(modalId); // Ruční otevření modálního okna
                }
            });
        });
    }
}
